import { AudioManager } from "../../AudioManager";
import { HelpParameters, Help, HelpPanelColor} from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { Panel, ButtonColors } from "../panel/panel";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_ResponsivePIXIApp } from "../SlotGameType1_ResponsivePIXIApp";
import { IWinLinesFactory } from "../WinLines/IWinLinesFactory";
import { SquareWinLinesFactory } from "../WinLines/SquareWinLineFactory";
// namespace SlotGames
// {

export class FiestaEnchilada_ResponsivePIXIApp extends SlotGameType1_ResponsivePIXIApp {

    
    constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
        super(multigameParams, initData, "FiestaEnchilada");

        this.spinnableReelsParams.topBorderWidth = 8;
        this.spinnableReelsParams.bottomBorderWidth = 8;
    }

	// protected PrepareFonts(resourceManager: ResourceManager): void 
	// {
		
	// 	resourceManager.Add(new FontResource(this.basepath +"resources/MexicanTequila.ttf",this.resid.ScopedResourceName(["BigSymbolFreeGames-font"])));
	
	// }

    
}
// }